import { useContext } from 'react'

import { Box, Icon } from '@fairfashion/design-system'
import { Position } from 'reactflow'

import { SegmentsDataContext } from '../../../../contexts/segments'
import { docMask } from '../../../../utilities/masks/brasilianDocuments'
import { ProvidersNodeData } from '../../index.types'

import * as Styles from './provider-node.styles'

export function ProviderNode({
  data,
  sourcePosition,
}: {
  data: ProvidersNodeData
  sourcePosition?: any
}) {
  const { segments } = useContext(SegmentsDataContext)

  const { onNodeExpand } = data

  const segment = segments.find((item) => item.name === data.segment)

  const transformText = (text = '') => {
    if (!text) return ''

    if (text.length === 2) {
      return text.toUpperCase()
    }
    return text.toLowerCase()
  }

  const direction =
    sourcePosition === 'right' || sourcePosition === 'left' ? 'LR' : 'TB'

  const color = data.status === 'inactive' ? '#aaaaaa' : segment?.color
  const textColor = data.status === 'inactive' ? '#aaaaaa' : undefined

  return (
    <>
      <Styles.CustomHandle
        type="target"
        position={direction === 'LR' ? Position.Left : Position.Top}
      />

      <Styles.Node>
        <Styles.SegmentText color={color ?? 'transparent'}>
          <span></span>
          {segment?.translate}
        </Styles.SegmentText>
        <Box marginTop={1} width="90%" direction="column">
          <Styles.SmallText color={textColor ?? ''}>
            {transformText(data.provider)}
          </Styles.SmallText>
          <Styles.SmallText color="grey_3">
            {docMask(data.taxId ?? '')}
          </Styles.SmallText>
          <Box marginTop={1}>
            <Styles.SmallText color={textColor ?? ''}>{`${transformText(
              data?.address?.city,
            )} - ${transformText(data?.address?.state)}`}</Styles.SmallText>
          </Box>
        </Box>
        {data.status === 'inactive' && (
          <Box justifyContent="flex-end" width="100%">
            <Styles.StatusText>Inativo</Styles.StatusText>
          </Box>
        )}
        {data.hasPreviousItems && !data.expandedPrevious && (
          <Styles.ExpandButtonPrevious
            direction={direction}
            onClick={() => onNodeExpand?.(data.id, 'previous')}
          >
            <Icon name="add" color="secondary" size={16} />
          </Styles.ExpandButtonPrevious>
        )}
        {data.hasNextItems && !data.expandedNext && (
          <Styles.ExpandButtonNext
            direction={direction}
            onClick={() => onNodeExpand?.(data.id)}
          >
            <Icon name="add" color="secondary" size={16} />
          </Styles.ExpandButtonNext>
        )}
      </Styles.Node>
      <Styles.CustomHandle
        type="source"
        position={direction === 'LR' ? Position.Right : Position.Bottom}
      />
    </>
  )
}
